import PageHeader from "../../common/page-header"
import { useEffect, useState } from "react"
import Paper from "@mui/material/Paper"
import Box from "@mui/material/Box"
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid"
import {
  Backdrop,
  Button,
  Card,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material"
import CreateInventory from "./create"
import { Inventories } from "../../../../api/Endpoints/Inventory"
import { blue, red } from "@mui/material/colors"
import DeleteMoadal from "./deleteModal"
import moment from "moment"
import BasicTabs from "./TabMenu"
import { useForm } from "react-hook-form"
import { VendorsApi } from "../../../../api/Endpoints/Vendors"
import SelectX from "../../../form/SelectX"
import { categories } from "../../../../api/Endpoints/Category"
import DateInput from "../../../form/DateInput"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import { AssignUser } from "../../../../api/Endpoints/Assign"
import { Employee } from "../../../../api/Endpoints/Employee"
const Inventory = () => {
  const [refresh, setRefresh] = useState(false)
  const [editId, setEditId] = useState()
  const [pageNumber, setPageNumber] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [rowsDetails, setrowsDetails] = useState({})
  const [detailViewId, setDetailViewId] = useState(false)
  const [deleteId, setDeleteId] = useState(false)
  const [searchKeyword, setSearchKeyword] = useState()

  const handleCreate = () => {
    setEditId(0)
    setRefresh(Math.random)
  }

  const handlePageChange = (page) => {
    setPageNumber(page)
  }

  const handleUpdate = (details) => {
    // handleCreate()
    // setEditId()
    // console.log(editId);
    // setrowsDetails(details)
    // console.log(details);
    setPageNumber()
    setPageNumber(0)
  }

  const TitleB = {
    color: "blue",
    cursor: "pointer",
  }

  const fetchList = () => {
    setLoading(true)
    Inventories.list({
      keyword: searchKeyword,
      page: Number(pageNumber) + 1,
      category_id: watch('category')?.id,
      vendor_id: watch('vendor')?.id,
      from: watch('from') && moment(watch('from')).format('YYYY-MM-DD'),
      to: watch('to') && moment(watch('to')).format('YYYY-MM-DD'),
      using_by: watch('assign_to')?.id
    }).then((response) => {
      setList(response.data.data)
      setLoading(false)
    })
  }

  const handleEdit = (id) => {
    setRefresh(Math.random)
    setEditId(parseInt(id))
  }

  const deleteItem = (id) => {
    setDeleteId(id)
  }
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    setValue,
    getValues,
    reset,
  } = useForm()

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
      renderCell: (params) => (
        <p>{params.row.id}</p>
        // <p  onClick={viewTabs}>{params.row.title}</p>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      width: 350,
      renderCell: (params) => (
        <p style={TitleB} onClick={() => DetailViewOpen(params.id)}>
          {params.row.name}
        </p>
        // <p  onClick={viewTabs}>{params.row.title}</p>
      ),
    },
    {
      field: "vendor",
      headerName: "Vendor",
      width: 180,
      renderCell: (params) => <>{params.row.vendor?.name}</>,
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
      renderCell: (params) => <>{params.row.category?.name}</>,
    },
    {
      field: "assigned_to",
      headerName: "Assigned To",
      width: 150,
      renderCell: (params) => <>{params.row.current_user?.name}</>,
    },
    {
      field: "purchased_on",
      headerName: "Purchased Date",
      width: 100,
      renderCell: (params) => (
        <>{params.value ? moment(params.value).format("DD-MM-YYYY") : ""}</>
      ),
    },
    {
      field: "edit",
      headerName: "",
      width: 60,
      renderCell: (params) => (
        <Button onClick={() => handleEdit(params.id)}>
          <EditIcon />
        </Button>
      ),
    },
    {
      field: "delete",
      headerName: "",
      width: 100,
      renderCell: (params) => (
        <Button onClick={() => deleteItem(params.id)} color="error">
          <DeleteIcon sx={{ color: "red" }} />
        </Button>
      ),
    },
  ]

  const color = red[400]
  const Bstyle = {
    bgcolor: color,
    height: "30px",
    color: "white",
    marginLeft: "auto",
    "&:hover": {
      color: "black",
      backgroundColor: "lightblue",
    },
  }

  const editColor = blue[400]
  const EditBstyle = {
    bgcolor: editColor,
    height: "30px",
    color: "white",
    marginLeft: "auto",
    "&:hover": {
      color: "black",
      backgroundColor: "lightblue",
    },
  }

  const DetailViewOpen = (id) => {
    setDetailViewId(id)
  }

  useEffect(() => {
    fetchList()
  }, [pageNumber, searchKeyword, watch('category'), watch('vendor'), watch('from'), watch('to'), watch('assign_to')])

  const handleSearchEntry = (event) => {
    setSearchKeyword(event.target.value)
  }
  const fetchVendor = (e) => {
    return VendorsApi.list({ keyword: e }).then((response) => {
      if (typeof response.data.data.data !== "undefined") {
        return response.data.data.data
      } else {
        return []
      }
    })
  }
  const fetchCategory = (e) => {
    return categories.list({ keyword: e }).then((response) => {
      if (typeof response.data.data.data !== "undefined") {
        return response.data.data.data
      } else {
        return []
      }
    })
  }
  const fetchEmployees = (e) => {
    return Employee.get({ keyword: e }).then(response => {
      if (typeof response.data.data.data !== 'undefined') {
        return response.data.data.data;
      } else {
        return [];
      }
    });
  };

  const handleClearSearch = () => {
    reset()
    setValue("vendor", null)
    setValue("category", null)
    setValue('assign_to', null)
    setSearchKeyword(null)
  }
  return (
    <>
      {detailViewId && (
        <BasicTabs id={detailViewId} handleClose={setDetailViewId} />
      )}

      {deleteId && (
        <DeleteMoadal
          id={deleteId}
          handleOpen={setDeleteId}
          refresh={handleUpdate}
          statement={"Inventory"}
        />
      )}

      <PageHeader title={"Inventory"} />

      <Card
        sx={{ p: 2, display: "flex", justifyContent: "end" }}
        variant="outlined"
      >
        <Grid container spacing={1}>
          <Grid item xs={6} sx={{ mt: 1 }}>
            <TextField
              id="outlined-name"
              autoFocus
              label="Search"
              name="search"
              value={searchKeyword}
              onChange={handleSearchEntry}
            />
          </Grid>
          <Grid item xs={6}>
            <SelectX
              key={refresh * 0.2}
              label={"Vendor"}
              options={fetchVendor}
              control={control}
              name={"vendor"}
              defaultValue={watch("vendor")}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1} pl={1}>

          <Grid item xs={6}>
            <SelectX
              key={refresh * 0.2}
              label={"Category"}
              options={fetchCategory}
              control={control}
              name={"category"}
              defaultValue={watch("category")}
            />
          </Grid>
          <Grid item xs={6}>
            <SelectX
              key={refresh * 0.2}
              label={"Assign To"}
              options={fetchEmployees}
              control={control}
              name={"assign_to"}
              defaultValue={watch("assign_to")}
            />
          </Grid>
        </Grid>
        <Grid container spacing={1} pl={1}>
          <Grid item xs={6}>
            <DateInput
              control={control}
              name="from"
              label="From"
              value={watch("from")}
            />
          </Grid>

          <Grid item xs={6}>
            <DateInput
              control={control}
              name="to"
              label="To"
              value={watch("to")}
            />
          </Grid>
        </Grid>
        <Grid item xs={6} sx={{ pt: 3 }}>
          <Button variant="outlined" onClick={handleClearSearch}>
            Clear
          </Button>
        </Grid>
        <CreateInventory
          rowdetails={rowsDetails}
          key={refresh}
          onNew={handleCreate}
          onUpdate={handleUpdate}
          editId={editId}
          setEditId={setEditId}
        />
      </Card >

      <Card sx={{ m: 2 }} variant="outlined">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {list && (
          <DataGrid
            paginationMode="server"
            rows={list?.data}
            columns={columns}
            page={pageNumber}
            pageSize={10}
            rowHeight={30}
            rowCount={list?.total}
            rowsPerPageOptions={[10]}
            onPageChange={handlePageChange}
            autoHeight
            density={"comfortable"}
          />
        )}
      </Card>
    </>
  )
}

export default Inventory
